import { CommonModule } from '@angular/common';
// This Module's Components
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FlightPlusHotelComponent } from './flight-plus-hotel.component';

@NgModule({
  declarations: [FlightPlusHotelComponent],
  exports: [FlightPlusHotelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, ModalModule.forRoot()],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class FlightPlusHotelModule {}
